import { ItemTypeProperty } from "chat/components/hooks/useProfileAvatarClickTracker";
import { EventFields, SCREEN_NAME, emitUiAction } from "chat/imports/analytics";
import { BadgeType, LiveBarClickTargetProperty } from "chat/liveBar/types";

interface EmitLiveBarItemClickedParams {
  peerId: string;
  position: number;
  streamId: string;
  text: string;
}

interface TextValue {
  isAccessToPremiumEnabled: boolean;
  isPremiumEnabled: boolean;
  streamKind?: number;
}

export const getTextValue = ({
  streamKind,
  isAccessToPremiumEnabled,
  isPremiumEnabled,
}: TextValue): string => {
  let text = "";

  if (streamKind === 2) {
    text = BadgeType.LIVE;
  } else if (isAccessToPremiumEnabled && isPremiumEnabled) {
    text = BadgeType.PREMIUM;
  }

  return text;
};

export const emitLiveBarItemClicked = ({
  streamId,
  peerId,
  position,
  text,
}: EmitLiveBarItemClickedParams) => {
  emitUiAction({
    target: LiveBarClickTargetProperty.LIVE_STREAM_COVER,
    tango_screen: SCREEN_NAME.MAIN_CONVERSATIONS,
    additionalParams: {
      [EventFields.STREAM_ID]: streamId,
      [EventFields.PEER_ID]: peerId,
      [EventFields.POSITION]: position,
      [EventFields.TEXT]: text,
      [EventFields.ITEM_TYPE]: ItemTypeProperty.LIVE_BAR,
    },
  });
};
